<input type="password" [ngClass]="(isFocus || cfetService.pwdObj.currentPassword[index] && !isSonim) ? 'focusOn' : '' "
    class="col-md-12 paddingRt"
    [value]="cfetService.pwdObj.isErrorCodeArray[index] ? '' : cfetService.pwdObj.currentPassword[index]" tabindex="0"
    (click)="pwdKeyup($event, index)" (keyup)="pasteMouseClick=true;pwdKeyup($event, index)"
    (keypress)="checkForSpecialChars($event)" (paste)="checkForSpecialCharsPaste($event, index)" (blur)="pwdBlur(index)"
    [id]="'new-password'+index" autocomplete="off" [type]="showPwd[index] ? 'text' : 'password'"
    aria-label="create-password">
<span *ngIf="cfetService.pwdObj.currentPassword[index] && !isSonim" class="pwd_close_icon padRight35"
    [id]="'cross-icon-pwd'+index">
    <img id="close" (keyup)="resetField($event, index)" (click)="resetField($event, index)"
        src="assets/images/C100_Close_16.png" alt="Close" role="img" tabindex="0" aria-label="icon-close">
    <img id="line" src="assets/images/Line.png" alt="Line" role="img" aria-label="icon-line">
</span>
<span *ngIf="cfetService.pwdObj.currentPassword[index] && !isSonim || isFocus"
    [ngClass]="{'pwd_icon_hide': showPwd[index], 'pwd_icon_show' : !showPwd[index]}" class="padLeft15 marginRt15"
    [id]="'pwd-icon'+index" (keyup)="showHidePassword($event)" (click)="showHidePassword($event)">
    <img *ngIf="showPwd[index]" id="blue_eye" src="assets/images/Eye_Icon_blue_hide.png" alt="BlueEye" role="img"
        tabindex="0" aria-label="icon-eye-hide">
    <img *ngIf="!showPwd[index]" id="blue_eye" src="assets/images/Eye_Icon_blue.png" alt="BlueEye" role="img"
        tabindex="0" aria-label="icon-eye-show">
</span>
<span *ngIf="!isSonim && !cfetService.pwdObj.currentPassword[index] && !isFocus"
    [ngClass]="{'pwd_icon_hide': showPwd[index], 'pwd_icon_show' : !showPwd[index]}" class="padLeft15 marginRt15"
    [id]="'pwd-icon'+index" (keyup)="showHidePassword($event)" (click)="showHidePassword($event)">
    <img *ngIf="showPwd[index]" src="assets/images/Eye_Icon_black_hide.png" alt="Eye" role="img" tabindex="0"
        aria-label="icon-eye-hide">
    <img *ngIf="!showPwd[index]" src="assets/images/Eye_Icon_black.png" alt="Eye" role="img" tabindex="0"
        aria-label="icon-eye-show">
</span>

<div *ngIf="errorFlagArray[index] || cfetService.pwdObj.isErrorCodeArray[index] === 7007">
    <div aria-live="polite" aria-atomic="true" class="error-msg" role="alert">
        <em class="icon-badgealert" aria-hidden="true"></em>
        <span>{{cfetMessages.valid_password}}</span>
    </div>
</div>
<div [hidden]="isSonim" class="abs-helpertext" id="tooltipContent1" role="tooltip" tabindex="-1">
    <span class="popover-content">
        <ng-container *ngTemplateOutlet="sonimBlock"></ng-container>
    </span>
</div>
<div [hidden]="!isSonim" class="sonim-pwd-req-con">
    <ng-container *ngTemplateOutlet="sonimBlock"></ng-container>
</div>

<ng-template #sonimBlock>
    <p [ngClass]="{'pwd-must-para': isSonim}">{{cfetMessages.pd_rule_title1_new}}</p>
    <ul [ngClass]="{'sonim-ul': isSonim}">
        <li *ngFor="let rule of ruleHeaders" aria-live="polite" aria-atomic="true">
            <span [ngStyle]="isSonim && {'margin-top': '4px', 'vertical-align': 'top'}" id="{{rule}}{{index}}"
                [ngClass]="{'icon-approval': cfetService.pwdObj.pdRules[index][rule], 'icon-round-sonim': !cfetService.pwdObj.pdRules[index][rule] && isSonim,
            'icon-round': !cfetService.pwdObj.pdRules[index][rule] && !isSonim, 'gray-icon-approval': isSonim}">&nbsp;</span>
            <span [ngClass]="{'marL5': isSonim}" [innerHTML]="cfetMessages[rule]"></span>
        </li>
    </ul>
    <p id="heading2" [ngClass]="{'pwd-must-para': isSonim}" [innerHTML]="cfetMessages.pd_rule_title2"></p>
    <p id="heading2_mobile" [ngClass]="{'pwd-must-para': isSonim}">{{cfetMessages.pd_rule_title2_mobile}}</p>
    <ul [ngClass]="{'sonim-ul': isSonim}">
        <li *ngFor="let rule of unRuleHeaders">
            <span [ngStyle]="isSonim && {'margin-top': '4px', 'vertical-align': 'top'}" id="{{rule}}{{index}}"
                [ngClass]="{'icon-approval': cfetService.pwdObj.pdRules[index][rule], 'icon-round-sonim': !cfetService.pwdObj.pdRules[index][rule] && isSonim,
        'icon-round': !cfetService.pwdObj.pdRules[index][rule] && !isSonim, 'gray-icon-approval': isSonim}">&nbsp;</span>
            <span [ngClass]="{'marL5': isSonim}" [innerHTML]="cfetMessages[rule]"></span>
        </li>
    </ul>

</ng-template>